/*
 * @Author: wufei
 * @Date: 2020-08-07 11:01:31
 * @LastEditTime: 2020-08-24 15:08:39
 * @Description:
 * @FilePath: \mobile-revive\src\store\mutations-types.js
 */
// 加载状态
export const CHANGLOADING = 'changLoading'

// 判断页面时前进还是后退
export const CHANGGOORBACK = 'changGoOrBack'

// 钉钉配置
export const MU_DDCONFIG = 'mu_ddConfig'

// 钉钉用户信息
export const MU_USERINFO = 'mu_userInfo'

// 查看其他人意见是否可见
export const MU_PEROTHERPER = 'mu_perOtherPer'

// 判断是否是集团区域对接人（只有查看功能 查看地块详情和投票结果）
export const MU_GRELEADER = 'mu_GReLeader'

// 审核意见（审核意见太多，全局处理）
export const MU_GTEXTAREA = 'mu_Gtextarea'

// 其他url参数
export const MU_OTHERQUERYS = 'mu_OtherQuerys'
